export enum DonationRoundUpPromptType {
  None = 'none',
  Custom = 'custom',
  Predefined = 'predefined',
}
